"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.generate = generate;
var _nanoid = require("nanoid");
// A passthrough method to prepend cnqr- to every automatically generated ID.
const nanoid = (0, _nanoid.customAlphabet)('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', 10);
function generate() {
  return `cnqr-${nanoid()}`;
}
var _default = exports.default = {
  generate
};